/* import __COLOCATED_TEMPLATE__ from './upload.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-upload';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_ERROR = `${CLASS_NAME}--error`;
const CLASS_NAME_HOVER = `${CLASS_NAME}--hover`;
const CLASS_NAME_LABELED = `${CLASS_NAME}--labeled`;
const CLASS_NAME_LABELED_BOTH = `${CLASS_NAME}--labeled-both`;
const CLASS_NAME_LOADING = `${CLASS_NAME}--loading`;
const CLASS_NAME_SHINY = `${CLASS_NAME}--shiny`;

/** @class */
class GlmUpload extends Component {
  @tracked isHoveringIcon = false;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
      this.isDisabled && CLASS_NAME_DISABLED,
      this.args.error && CLASS_NAME_ERROR,
      this.showHover && CLASS_NAME_HOVER,
      this.hasLabel && CLASS_NAME_LABELED,
      this.hasBothLabels && CLASS_NAME_LABELED_BOTH,
      this.args.isLoading && CLASS_NAME_LOADING,
      this.args.shine && CLASS_NAME_SHINY,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get hasLabel() {
    return this.args.titleText || this.args.helperText;
  }

  get hasBothLabels() {
    return this.args.titleText && this.args.helperText;
  }

  get isDisabled() {
    return this.args.isLoading
      || this.args.disabled;
  }

  get showHover() {
    return !this.isDisabled
      && !this.args.uploaded
      && this.isHoveringIcon;
  }

  /**
   * @param {string} id
   * @param {KeyboardEvent} e
   */
  @action
  accessibilityTriggerFileInput(id, e) {
    // add 'Enter' accessability when focused
    if (e.key === 'Enter') {
      // trigger the hidden file input
      document.getElementById(id).click();
    }

    this.args.onkeyup?.();
  }

  /**
   *
   */
  @action
  onMouseEnterIconArea() {
    this.isHoveringIcon = true;

    this.args.mouseenter?.();
  }

  /**
   *
   */
  @action
  onMouseLeaveIconArea() {
    this.isHoveringIcon = false;

    this.args.mouseleave?.();
  }

  /**
   * @param {string} id
   */
  @action
  triggerFileInput(id) {
    // trigger the hidden file input
    document.getElementById(id).click();

    this.args.onclick?.();
  }
}

export default GlmUpload;
